export const fmtEur = (v) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(v || 0));

export const fmtNum = (v) =>
  new Intl.NumberFormat("de-DE", { maximumFractionDigits: 2 }).format(Number(v || 0));

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = String(s).slice(0, 10).split("-");
  if (d.length !== 3) return s;
  return `${d[2]}.${d[1]}.${d[0]}`;
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const addDaysISO = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};

export const computeTotals = (items) => {
  let subtotal = 0;
  let tax = 0;
  (items || []).forEach((it) => {
    const line = Number(it.quantity || 0) * Number(it.unit_price || 0);
    subtotal += line;
    tax += (line * Number(it.tax_rate || 0)) / 100;
  });
  return {
    subtotal: Math.round(subtotal * 100) / 100,
    tax_total: Math.round(tax * 100) / 100,
    total: Math.round((subtotal + tax) * 100) / 100,
  };
};
